// extracted by mini-css-extract-plugin
export default {"searchContainer":"ParticipantSearch__searchContainer___XDnRE"};